module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAUCAYAAABxnDbHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACgSURBVHgB7ZbRCYAwDAWf4gC6QR3BCe0GuoGjiRPoBjHBFIpQUCEVxIP8pJqr0jYFFCLqOVayQeoOwVWqUBKtRGEA1+04GvZ4RF8pM3EwhOvX4okThAwET4kXKOIZZMIhp/TV3/tLvyet7jycWOUOx9abE685PgmXx1I9R5PDuMi/kLJIN2k9MERb5xYnPMdk1VO1l0r98Twwku11xQfXDlyeEbMWy3NyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/Cart/credit-card.png
// module id = 557
// module chunks = 0